export default __webpack_public_path__ + "static/media/image-success.87aa7c0d.png";